import { render, staticRenderFns } from "./heart-beat.vue?vue&type=template&id=2817cf39&"
import script from "./heart-beat.vue?vue&type=script&lang=ts&"
export * from "./heart-beat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports